import { useEffect, useMemo, useState } from 'react'

interface LogoProps {
  className?: string
  theme?: 'light' | 'dark' | 'auto'
}

export function Logo({ className = '', theme = 'auto' }: LogoProps) {
  const [autoDarkMode, setAutoDarkMode] = useState(false)

  useEffect(() => {
    if (theme !== 'auto') return

    // Check if dark mode is active
    const checkDarkMode = () => {
      const isDark = document.documentElement.classList.contains('dark')
      setAutoDarkMode(isDark)
    }

    // Initial check
    checkDarkMode()

    // Watch for theme changes
    const observer = new MutationObserver(checkDarkMode)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    })

    return () => observer.disconnect()
  }, [theme])

  const isDarkMode = useMemo(() => {
    if (theme === 'auto') return autoDarkMode
    return theme === 'dark'
  }, [theme, autoDarkMode])

  const logoSrc = isDarkMode
    ? '/images/agion-logo-white-transparent.webp'
    : '/images/agion-logo-black-transparent.webp'

  return (
    <img
      src={logoSrc}
      alt="Agion"
      className={`h-8 w-auto ${className}`}
    />
  )
}
